<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="pa-2 rounded elevation-1 bg-white">
                        <div class="d-flex align-center ga-2 flex-wrap">
                            <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })"
                                density="compact" variant="outlined">
                                <v-icon left>mdi-arrow-left</v-icon>
                                Retour
                            </v-btn>

                        </div>
                        <div class="text-h6 mt-2 mb-4">Inscriptions multiparcours à {{ mainStore.module.nom }}</div>

                        <div v-if="multi">
                            <v-btn color="primary-dark" @click="exportTsv" variant="tonal"
                                :disabled="!multi?.inscrits?.length">
                                <v-icon left>mdi-download</v-icon>
                                Exporter la liste
                            </v-btn>
                            <div>Il y a {{ multi.nb_multi_inscrits }} participants qui sont inscrits à au moins deux
                                parcours.</div>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">Nom</th>
                                            <th class="text-left">Prénom</th>
                                            <th class="text-left">Parcours</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(inscrit, index) in multi.inscrits" :key="index">
                                            <td>{{ inscrit.nom }}</td>
                                            <td>{{ inscrit.prenom }}</td>
                                            <td><v-chip density="compact" class="ma-1"
                                                    v-for="(course, index_course) in inscrit.courses"
                                                    :key="index_course">{{ course }}</v-chip></td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";


export default {
    components: {},
    data() {
        return {
            multi: null
        };
    },
    computed: {
        ...mapStores(useMainStore),
    },
    async created() {
        let request = await AdminService.getListInscritsMultiParcours(this.mainStore.module.id);
        if (request) {
            this.multi = request;
        }

    },
    methods: {
        exportTsv() {
            if (!this.multi?.inscrits?.length) return;
            const maxCourses = Math.max(
                ...this.multi.inscrits.map((i) => (Array.isArray(i.courses) ? i.courses.length : 0)),
                1
            );
            const headers = [
                "Nom",
                "Prénom",
                ...Array.from({ length: maxCourses }, (_, i) => `Parcours ${i + 1}`),
            ];
            const rows = this.multi.inscrits.map((inscrit) => {
                const courses = Array.isArray(inscrit.courses) ? inscrit.courses : [];
                const parcoursCols = Array.from({ length: maxCourses }, (_, i) => courses[i] ?? "");
                return [inscrit.nom ?? "", inscrit.prenom ?? "", ...parcoursCols];
            });
            const escapeTsv = (val) => {
                const str = String(val ?? "");
                if (str.includes("\t") || str.includes('"') || str.includes("\n")) {
                    return `"${str.replace(/"/g, '""')}"`;
                }
                return str;
            };
            const tsvContent = [
                headers.map(escapeTsv).join("\t"),
                ...rows.map((row) => row.map(escapeTsv).join("\t")),
            ].join("\n");
            const blob = new Blob(["\ufeff" + tsvContent], { type: "text/tab-separated-values;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `inscrits-multiparcours-${this.mainStore.module.nom || "export"}-${new Date().toISOString().slice(0, 10)}.tsv`;
            link.click();
            URL.revokeObjectURL(url);
        },
    },
};
</script>

<style lang="scss" scoped></style>